export const CUSTOMER_KEY = "tmiCustomerKey"
export const CHECKOUT_KEY = "tmiCheckoutKey"
export const DISCOUNT_KEY = "tmiDiscountKey"
export const COOKIE_POLICY_KEY = "tmiCookiePolicyKey"
export const MODULE = "tmiModule"
export const RECENTLY_VIEWED_PRODUCTS_KEY = "tmiRecentlyViewedProductsKey"
